// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"QR-z","categoryName":"RR-z","categoryNameSearchHeader":"SR-z","categoryContent":"TR-z","bottomAligned":"UR-z","image":"VR-z","imageNoBackground":"WR-z"};